import { AbstractDevicePricingItem } from "./abstract-device-pricing-item";

export class PackPricingItem extends AbstractDevicePricingItem {
}
